// (A) 중립 Layout API — antd 미접촉. (B) PlainLayout* 에 위임.
// antd Layout / Layout.Header/Content/Sider 복합을 개별 컴포넌트로 분리.
import type { CSSProperties, ReactNode } from 'react'
import {
  PlainLayout,
  PlainLayoutContent,
  PlainLayoutHeader,
  PlainLayoutSider,
} from '../_impl/PlainLayout'

export interface OmwLayoutProps {
  className?: string
  style?: CSSProperties
  children?: ReactNode
}

export interface OmwLayoutHeaderProps {
  className?: string
  style?: CSSProperties
  children?: ReactNode
}

export interface OmwLayoutContentProps {
  className?: string
  style?: CSSProperties
  children?: ReactNode
}

export interface OmwLayoutSiderProps {
  width?: number | string
  collapsedWidth?: number | string
  collapsible?: boolean
  collapsed?: boolean
  onCollapse?: (collapsed: boolean) => void
  /** 실측: 'lg'(MenuLeft 반응형). */
  breakpoint?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'
  className?: string
  style?: CSSProperties
  children?: ReactNode
}

export function OmwLayout(props: OmwLayoutProps) {
  return <PlainLayout {...props} />
}

export function OmwLayoutHeader(props: OmwLayoutHeaderProps) {
  return <PlainLayoutHeader {...props} />
}

export function OmwLayoutContent(props: OmwLayoutContentProps) {
  return <PlainLayoutContent {...props} />
}

export function OmwLayoutSider(props: OmwLayoutSiderProps) {
  return <PlainLayoutSider {...props} />
}
